import { useUser } from "../api/user";
import { Button } from "@/components/ui/button";
import { useAppContext } from "@/providers/app-context";

const ImpersonationIndicator = () => {
  const user = useUser();
  const { impersonatingUser, stopImpersonatingUser } = useAppContext();
  if (!user || !user?.data) {
    return null;
  }
  if (impersonatingUser) {
    return (
      <div className="sticky top-0 z-[100] flex w-full flex-row justify-center gap-x-2 bg-red-500 py-1 text-center text-white">
        <div>
          Impersonating <span className="font-bold">{user.data?.email}</span>{" "}
        </div>
        <div>//</div>
        <Button
          variant="link"
          className="h-6 p-0 font-bold text-white"
          onClick={stopImpersonatingUser}
        >
          Stop impersonation
        </Button>
      </div>
    );
  }
  return null;
};

export default ImpersonationIndicator;
